import { Modal } from "antd";
import FooterModal from "ui/components/Button/FooterModal";
import { Flex, Text, Box } from "@chakra-ui/react";
import DateRangePicker from "ui/components/Input/DateRangePicker";
import SelectUnidade from "ui/components/Input/SelectUnidade";
import SelectPessoas from "ui/components/Input/SelectPessoas";
import SelectAreaComum from "ui/components/Input/SelectAreaComum";
import { useState, useEffect } from "react";
import { ReservaFiltroAdv } from "core/features/reservas/typings";
import { StatusReservaEnum } from "core/features/reservas/typings";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import { CloseModalButton } from "components/Button/CloseModalButton";
import Toolbar from "ui/components/Toolbar";
import SelectTipoDataReservas from "components/Input/SelectTipoDataReservas";
import FiltroTagTipoPagamento from "./../FiltroTagTipoPagamento";
import FiltroTagOrigemCriacao from "./../FiltroTagOrigemCriacao";
import { useRegrasTenant } from "core/features/tenants/tenants.context";
import SelectTenant from "components/Input/SelectTenant";
import FiltroTagStatusReserva from "../../../../../../../components/Tags/FiltroTagStatusReserva";

interface ModalFiltrosProps {
  isOpen: boolean;
  onClose: () => any;
  onSave: () => any;
  tenantId: string;
  filtro: ReservaFiltroAdv;
  onChangeFiltro: (filtro: Partial<ReservaFiltroAdv>) => any;
  onReset: (filtro?: Partial<ReservaFiltroAdv>) => any;
  selectTipoDataReservas?: boolean;
}

function ModalFiltros({
  isOpen,
  onClose,
  onSave,
  tenantId,
  filtro,
  onChangeFiltro,
  onReset,
  selectTipoDataReservas,
}: ModalFiltrosProps) {
  const { useSubtenantsViews } = useRegrasTenant();
  const [localFiltro, setLocalFiltro] = useState<ReservaFiltroAdv>(filtro);

  useEffect(() => {
    setLocalFiltro(filtro);
  }, [filtro]);

  return (
    <Modal
      visible={isOpen}
      onCancel={onClose}
      className="antd-custom-header"
      title={
        <Toolbar title="Filtros avançados" onClose={onClose} border="0px" />
      }
      closable={false}
      width="900px"
      centered
      footer={
        <Flex
          justifyContent="end"
          align="center"
          gap="8px"
          alignContent="center"
          alignItems="center"
        >
          <CloseModalButton
            closeModalLabel="Fechar"
            close={onClose}
            mt="32px"
          />
          <FooterModal
            isDisabled={false}
            onSubmit={() => {
              onChangeFiltro(localFiltro);
              onSave();
            }}
            onClose={() => {
              onReset();
              onClose();
            }}
            showRegisterAnother={false}
            primaryButtonText="Filtrar"
            buttonCancelarText="Limpar filtros"
            isLoadingSave={false}
            showBorderTop={false}
          />
        </Flex>
      }
    >
      {useSubtenantsViews ? (
        <Box columnGap={2} mb="25px">
          <Text fontWeight="bold" mb="10px">
            Condomínio(s)
          </Text>
          <SelectTenant
            mode="multiple"
            onChange={(tenantsIds) => {
              setLocalFiltro((state) => ({ ...state, tenantsIds }));
            }}
            value={localFiltro.tenantsIds}
            allowClear
            placeholder="Todos os condomínios"
          />
        </Box>
      ) : null}

      <Box>
        <Text fontWeight="bold" mb="10px">
          {useSubtenantsViews ? "Período" : "Período, unidade e morador"}
        </Text>

        <Flex columnGap={2}>
          <Box maxW="250px" w="100%">
            <DateRangePicker
              allowEmptyDates={{
                dataInicio: true,
                dataFim: false,
              }}
              onChange={(dataInicio, dataFim) => {
                setLocalFiltro((state) => ({ ...state, dataInicio, dataFim }));
              }}
              value={{
                dataInicio: localFiltro.dataInicio,
                dataFim: localFiltro.dataFim,
              }}
            />
          </Box>

          {selectTipoDataReservas ? (
            <SelectTipoDataReservas
              allowClear={true}
              bg="white"
              style={{ border: "1px solid #ccc", borderRadius: 6 }}
              value={localFiltro.tipoData}
              onChange={(v) =>
                setLocalFiltro((state) => ({ ...state, tipoData: v }))
              }
            />
          ) : null}

          {useSubtenantsViews ? (
            <>
              {/* <SelectUnidadeSubtenants
                tenantIds={localFiltro.tenantsIds ?? []}
                onChange={(unidadeId) => {
                  setLocalFiltro((state) => ({
                    ...state,
                    unidadeId,
                    pessoaId: undefined,
                  }));
                }}
                value={localFiltro.unidadeId}
                allowClear
                placeholder="Todas as unidades"
              />

              <SelectPessoasSubtenants
                tenantsIds={localFiltro.tenantsIds ?? []}
                tipoEntidades={[TipoEntidadeEnum.Condomino]}
                unidadeId={localFiltro.unidadeId}
                value={localFiltro.pessoaId}
                onChange={(pessoaId) => {
                  setLocalFiltro((state) => ({ ...state, pessoaId }));
                }}
                allowClear
                placeholder="Todos os moradores"
              /> */}
            </>
          ) : (
            <>
              <SelectUnidade
                tenantId={tenantId}
                onChange={(unidadeId) => {
                  setLocalFiltro((state) => ({
                    ...state,
                    unidadeId,
                    pessoaId: undefined,
                  }));
                }}
                value={localFiltro.unidadeId}
                allowClear
                placeholder="Todas as unidades"
              />
              <SelectPessoas
                tipoEntidades={[
                  TipoEntidadeEnum.Condomino,
                  TipoEntidadeEnum.Funcionario,
                ]}
                unidadeId={localFiltro.unidadeId}
                value={localFiltro.pessoaId}
                onChange={(pessoaId) => {
                  setLocalFiltro((state) => ({ ...state, pessoaId }));
                }}
                allowClear
                placeholder="Todos os moradores"
              />
            </>
          )}
        </Flex>
      </Box>

      <Box mt="25px">
        <Text fontWeight="bold" mb="10px">
          Área comum
        </Text>
        <SelectAreaComum
          value={localFiltro.areaComumId}
          onChange={(areaComumId) => {
            setLocalFiltro((state) => ({
              ...state,
              areaComumId,
            }));
          }}
        />
      </Box>

      <Box mt="25px">
        <Text fontWeight="bold" mb="10px">
          Status da reserva
        </Text>
        <FiltroTagStatusReserva
          selectedTipoStatus={localFiltro.status}
          setSelectedTipoStatus={(status) =>
            setLocalFiltro((state) => ({
              ...state,
              status: status as StatusReservaEnum,
            }))
          }
        />
      </Box>

      <Flex gap={10} mt="15px">
        <Box>
          <Text fontWeight="bold" mb="10px">
            Tipo de pagamento
          </Text>
          <FiltroTagTipoPagamento
            selectedTipoPagamento={localFiltro.tipoPagamento}
            setSelectedTipoPagamento={(selected) => {
              setLocalFiltro((state) => ({
                ...state,
                tipoPagamento: selected,
              }));
            }}
          />
        </Box>

        <Box>
          <Text fontWeight="bold" mb="10px">
            Origem
          </Text>
          <FiltroTagOrigemCriacao
            selectedOrigem={localFiltro.origem}
            setSelectedOrigem={(selected) => {
              setLocalFiltro((state) => ({
                ...state,
                origem: selected,
              }));
            }}
          />
        </Box>
      </Flex>
    </Modal>
  );
}

export default ModalFiltros;
